module.exports = __webpack_public_path__ + "img/mon-3.c02a93e5.png";